<template>
  <a-i-prompt
    :submit-fn="API.instance.getAudienceRecommendation"
    :thread-fn="API.instance.getAudienceThread"
    suggestion="messages.aiPromptCustomAudience"
    @on-complete="fetchSegments" />
</template>
<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import AIPrompt from '@/common/components/controls/AIPrompt.vue';
  import { FilterCollection, FilterComparisonOperator, QueryParams } from '@/common/models';
  import AudienceRecommendation from '@/common/models/ai/AudienceRecommendation';
  import ExternalSegment from '@/common/models/audience/ExternalSegment';
  import API from '@/org-app/api';
  import { mapOrgAppActions } from '@/utils/StateMapping';
  import UserNotifications from '@/utils/UserNotifications';

  const emits = defineEmits<{
    (e: 'suggested', segments: ExternalSegment[]): void;
  }>();
  const { getExternalSegments } = mapOrgAppActions();
  const i18n = useI18n();

  async function fetchSegments(recommendation: AudienceRecommendation) {
    if (!recommendation.segmentIDs.length) {
      UserNotifications.error({ title: null, message: i18n.t('messages.noAudienceRecommendation') });
      return;
    }
    const filter = FilterCollection.for('externalsegment_id', recommendation.segmentIDs, FilterComparisonOperator.IN);
    const queryParams = QueryParams.all(filter);
    const result = await getExternalSegments({ queryParams });
    emits('suggested', result.items);
  }
</script>
